// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"30":"cb48209d","124":"03e59b5f","184":"7296c4ce","426":"9263c51a"}[chunkId] + ".chunk.js";
};